import React from "react";
import KuikaCopyButton from "../../../../ui-kit/kuika-copy-button/kuika-copy-button";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

type CopyButtonVariant = "icon" | "text";
type CopyButtonSize = "sm" | "md" | "lg";

const VARIANTS: CopyButtonVariant[] = ["icon", "text"];
const SIZES: CopyButtonSize[] = ["sm", "md", "lg"];

const SNIPPET: string = "const copyTextToClipboard = async (text: string): Promise<boolean> => { ... };";

export const CopyButtonStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Copy button"
      componentName="KuikaCopyButton"
      sourcePath="ui-kit/kuika-copy-button"
      description="A copy-to-clipboard control whose glyph rolls from a copy icon to a check mark on success, then rolls back after 1.5 seconds."
    >
      <VariantGrid
        label="variant · size"
        caption="icon and text variants across three sizes — the icon variant always renders at the sm icon rung (isIcon forces sm); size still governs the text variant's icon-to-label gap"
        rows={VARIANTS}
        cols={SIZES}
        render={(variant: string, size: string): React.ReactNode => (
          <KuikaCopyButton variant={variant as CopyButtonVariant} size={size as CopyButtonSize} value={SNIPPET} />
        )}
      />
      <SpecRow
        label="Compact (xs)"
        caption="size xs — a 16px icon square on the icon rung for a value copied from a dense row; the sm glyph, a --radius-xs corner and the full 32px click area"
      >
        <KuikaCopyButton value={SNIPPET} size="xs" label="Copy key" />
      </SpecRow>
      <SpecRow label="Copyable code" caption="click to copy the snippet below to the clipboard, with custom labels">
        <KuikaCopyButton variant="text" value={SNIPPET} label="Copy snippet" copiedLabel="Snippet copied" />
      </SpecRow>
      <SpecRow
        label="Reset timing"
        caption="the check glyph holds for 1.5s (KUIKA_COPY_RESET_MS) before rolling back to the copy icon"
      >
        <KuikaCopyButton value={SNIPPET} />
      </SpecRow>
    </ShowcaseFrame>
  );
};
